<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', maxHeight: '90vh' }">
  <ng-template #header>
    <div class="flex w-full items-start justify-between">
      <div class="flex items-center gap-3">
        <div>
          <h2 class="text-surface-[#181D27]">Export report</h2>
          <p class="text-xs text-surface-500">
            {{ selectedCount() }} widget{{ selectedCount() === 1 ? '' : 's' }}
            selected for export
          </p>
        </div>
      </div>
      <button
        type="button"
        class="flex items-center justify-center rounded-md p-1 text-surface-400
          hover:bg-surface-100 hover:text-surface-700"
        (click)="visible.set(false)">
        <ng-icon name="phosphorX" class="text-base" />
      </button>
    </div>
  </ng-template>

  @if (loading()) {
    <div
      class="absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 rounded-lg
        bg-white/80 backdrop-blur-sm">
      <p-progress-spinner
        strokeWidth="4"
        [style]="{ width: '48px', height: '48px' }" />
      <p class="text-sm font-medium text-surface-700">Generating your file.</p>
      <p class="text-sm font-medium text-surface-700">
        This may take a few minutes.
      </p>
    </div>
  }

  <div class="flex flex-col gap-6 px-6 py-4">
    <!-- Export Format -->
    <div class="flex flex-col gap-3">
      <div class="grid grid-cols-2 gap-3">
        <button
          type="button"
          class="flex flex-col items-center gap-2 rounded-xl border-2 p-2 transition-colors"
          [class.border-secondary-400]="format() === 'pdf'"
          [class.bg-secondary-50]="format() === 'pdf'"
          [class.border-surface-200]="format() !== 'pdf'"
          (click)="format.set('pdf')">
          <div class="text-secondary-700">
            <ng-icon name="phosphorFilePdf" size="28px" />
          </div>
          <div class="text-center">
            <p class="font-bold text-surface-900">PDF</p>
            <p class="text-surface-700">Single executive document</p>
          </div>
        </button>

        <button
          type="button"
          class="flex flex-col items-center gap-2 rounded-xl border-2 p-2 transition-colors"
          [class.border-secondary-400]="format() === 'png'"
          [class.bg-secondary-50]="format() === 'png'"
          [class.border-surface-200]="format() !== 'png'"
          (click)="format.set('png')">
          <div class="text-secondary-700">
            <ng-icon name="phosphorImage" size="28px" />
          </div>
          <div class="text-center">
            <p class="font-bold text-surface-900">PNG</p>
            <p class="text-surface-700">High-resolution image (300 DPI)</p>
          </div>
        </button>
      </div>
    </div>

    <!-- File Name -->
    <div class="flex flex-col gap-2">
      <p class="text-sm font-bold text-surface-700">File Name</p>
      <input
        pInputText
        type="text"
        [ngModel]="fileName()"
        (ngModelChange)="fileName.set($event)"
        placeholder="Enter file name..." />
    </div>

    <!-- Document Preview -->
    <div class="flex flex-col gap-2">
      <p class="text-sm font-bold text-surface-700">Document Preview</p>
      <div
        class="max-h-[420px] overflow-y-auto rounded-lg border border-dashed border-surface-300">
        <!-- Widget rows -->
        <div class="flex flex-col gap-2 p-3">
          @for (html of safePreviewItems(); track $index) {
            <div class="rounded border border-surface-100">
              <div
                [innerHTML]="html"
                style="
                  zoom: 0.35;
                  pointer-events: none;
                  user-select: none;
                "></div>
            </div>
          }
        </div>

        <!-- Document footer -->
        <div
          class="sticky bottom-0 flex justify-between border-t border-surface-200 bg-white px-4
            py-2 text-xs text-surface-400">
          <span>Confidential — Generated by LenderHub</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex w-full items-center gap-2 px-2">
      <p-button
        variant="outlined"
        class="flex-1"
        styleClass="w-full"
        [injectAttribute]="[
          {
            CSSPath: 'button',
            attribute: 'analytics-label',
            value:
              { element: 'button', action: 'export_back_to_selection' }
              | analyticsLabelValue,
          },
        ]"
        (onClick)="back.emit()">
        <ng-icon name="phosphorArrowRight" class="rotate-180 text-sm" />
        Back to selection
      </p-button>
      <p-button
        class="flex-1"
        styleClass="w-full"
        [disabled]="loading()"
        (onClick)="download.emit({ format: format(), fileName: fileName() })">
        <ng-icon name="phosphorDownloadSimple" class="text-sm" />
        Generate
      </p-button>
    </div>
  </ng-template>
</p-dialog>
